import { useEffect, useState } from "react";
import Modal from "./Modal";
import "./ContactModal.scss";

/** 联系邮箱 */
export const CONTACT_EMAIL = "cloudstore@borderxlab.com";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;

/**
 * Contact Us 弹窗：展示邮箱地址，支持一键复制，
 * 点击邮箱按现有逻辑唤起邮箱客户端。
 */
const ContactModal: React.FC<{ open: boolean; onClose: () => void }> = ({
  open,
  onClose,
}) => {
  const [copied, setCopied] = useState(false);

  // 关闭后重置复制状态，下次打开是初始态
  useEffect(() => {
    if (!open) setCopied(false);
  }, [open]);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // 剪贴板不可用时静默失败，用户仍可手动复制或点击邮箱
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="cs-contact">
        <h3 className="cs-contact__title">Contact Us</h3>
        <div className="cs-contact__row">
          <a className="cs-contact__email" href={CONTACT_MAILTO}>
            {CONTACT_EMAIL}
          </a>
          <button
            type="button"
            className="cs-contact__copy"
            onClick={copyEmail}
          >
            {copied ? "Copied" : "Copy"}
          </button>
        </div>
        <div className="cs-contact__actions">
          <button
            type="button"
            className="cs-contact__cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ContactModal;
